module.exports = __webpack_public_path__ + "static/media/logo-with-name.a45fe1d8.svg";